import * as React from 'react';
import { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import { FaCloud, FaMoneyBillWave, FaPercentage, FaTimes } from 'react-icons/fa';
import TableLayout from '../../../shared/layout/table/TableLayout';
import { ErrorToast } from '../../../utils/toasters';
import { ContollingService } from '../ControllingService';
import { Row } from 'react-bootstrap';
import { ControllingCard } from './ControllingCard';
import { priceSplitter } from '../../../utils/helpers/NumberFormater';
import { OutgoingInvoicesFilter } from './OutgoingInvoicesFilter';
import { ITableColumn } from '../../../shared/components/TableSkeleton';
export interface ILongTermIncomingInvoiceStatistics {
    revenue: number;
    platformFee: number;
    saasRevenue: number;
}
const OUTGOING_INVOICES_COLUMNS: ITableColumn[] = [
    { label: 'Company name' },
    { label: 'Total campaigns' },
    { label: 'Completed campaigns' },
    { label: 'Revenue' },
    { label: 'Platform fee' },
    { label: 'Revenue incl. fee' },
];
export function OutgoingInvoices() {
    const [dataLoading, setDataLoading] = useState(true);
    const [outgoingInvoices, setOutgoingInvoices] = useState<any[]>([]);
    const [staticts, seuStaticts] = useState<ILongTermIncomingInvoiceStatistics | null>(null);
    const currentYear = new Date().getFullYear();
    const [filters, setFilters] = useState({
        page: 1,
        perPage: 15,
        id: '',
        totalPages: 0,
        comapnyId: undefined,
        year: currentYear,
    });
    const [statsLoading, setStatsLoading] = useState(true);
    const requestIdRef = React.useRef(0);

    const fetchOutgoingInvoices = (params: typeof filters, pageOverride?: number) => {
        const requestId = ++requestIdRef.current;
        setDataLoading(true);
        if (pageOverride === undefined) setStatsLoading(true);
        const page = pageOverride ?? params.page;

        ContollingService.getOutgoingInvoices({ ...params, page } as any)
            .then(({ data, page: responsePage, count, info }: any) => {
                if (requestId !== requestIdRef.current) return;

                const totalPages = Math.ceil(count / params.perPage);
                if (totalPages > 0 && page > totalPages) {
                    fetchOutgoingInvoices({ ...params, page: 1 });
                    return;
                }

                setOutgoingInvoices(data);
                seuStaticts(info);
                setFilters(prev => ({
                    ...prev,
                    page: responsePage,
                    totalPages,
                }));
            })
            .catch(err => {
                if (requestId === requestIdRef.current) ErrorToast(err);
            })
            .finally(() => {
                if (requestId === requestIdRef.current) {
                    setDataLoading(false);
                    setStatsLoading(false);
                }
            });
    };
    const handlePageChange = (page: number) => {
        fetchOutgoingInvoices(filters, page);
    };
    useEffect(() => {
        setFilters(prev => ({ ...prev, page: 1 }));
        fetchOutgoingInvoices({ ...filters, page: 1 });
    }, []);
    return (
        <>
            <div className="mb-5">
                <Row className="gap-y-4">
                    <ControllingCard
                        cardName="Total revenue"
                        icon={<FaMoneyBillWave />}
                        baseColor="primary"
                        total={staticts?.revenue ?? 0}
                        styleCard="h-100"
                        isLoading={statsLoading}
                    />
                    <ControllingCard
                        cardName="Total platform fee"
                        icon={<FaPercentage />}
                        baseColor="primary"
                        total={staticts?.platformFee ?? 0}
                        styleCard="h-100"
                        isLoading={statsLoading}
                    />
                    <ControllingCard
                        cardName="Total SaaS revenue"
                        icon={<FaCloud />}
                        baseColor="primary"
                        total={staticts?.saasRevenue ?? 0}
                        styleCard="h-100"
                        isLoading={statsLoading}
                    />
                </Row>
            </div>

            <Card
                className="mb-5 p-4"
                onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter') fetchOutgoingInvoices(filters);
                }}
            >
                <OutgoingInvoicesFilter
                    handleState={fetchOutgoingInvoices}
                    setState={setFilters}
                    offersFilter={filters}
                />
            </Card>

            <TableLayout
                pagination={filters}
                listLength={outgoingInvoices.length}
                handlePages={handlePageChange}
                isLoading={dataLoading}
                dataName={'invoices'}
                skeletonColumns={OUTGOING_INVOICES_COLUMNS}
                skeletonRows={filters.perPage}
            >
                <Table hover responsive>
                    <thead>
                        <tr>
                            {OUTGOING_INVOICES_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {outgoingInvoices.map(company => (
                            <tr key={company.companyId}>
                                <td>
                                    {company?.companyId ? (
                                        <>
                                            <span className="text-primary">({company?.companyId})</span>{' '}
                                            {company?.companyName}
                                        </>
                                    ) : (
                                        <span className="word-break text-danger">
                                            <FaTimes />
                                        </span>
                                    )}
                                </td>
                                <td>{Number(company.totalCampaigns) || 0}</td>
                                <td>{Number(company.completedCampaigns) || 0}</td>
                                <td>{priceSplitter(company.revenue ?? 0)} €</td>
                                <td>{priceSplitter(company.platformFee ?? 0)} €</td>
                                <td>{priceSplitter(company.revenueWithFee ?? 0)} €</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableLayout>
        </>
    );
}
